var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WorkAuthorisation50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdP8f_UI1q8OVzZgSaIbTa",
    x1: 15.478,
    x2: 34.518,
    y1: 0.586,
    y2: 52.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#427fdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#2668cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#1358bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c52bb"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "url(#VdP8f_UI1q8OVzZgSaIbTa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,9a4,4,0,1,0,4,4A3.99891,3.99891,0,0,0,24,9Zm0,6a2,2,0,1,1,2-2A2.00591,2.00591,0,0,1,24,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33,13H26a2,2,0,0,1-4,0H15a2,2,0,0,0-2,2V35a2.00006,2.00006,0,0,0,2,2H33a2.00006,2.00006,0,0,0,2-2V15A2,2,0,0,0,33,13Zm-2.16852,9.80629-7.48943,7.52446a.57476.57476,0,0,1-.81465,0l-4.60888-4.63044a.58115.58115,0,0,1,0-.81846l.81465-.81847a.57444.57444,0,0,1,.81459,0l3.38753,3.40217,6.267-6.29619a.57444.57444,0,0,1,.81459,0l.81465.81847A.58115.58115,0,0,1,30.83148,22.80629Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WorkAuthorisation50);
export default __webpack_public_path__ + "static/media/icons8-work-authorisation-50.b1413bbbf2db12db6b15d80e5b4c5e0b.svg";
export { ForwardRef as ReactComponent };